import type { MouseEventHandler } from 'react';
import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { openWindowByLink, useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { getStyleConfig } from '../../../constants/style-config';
import { StopDisplayTriggerTypes, useBarState } from '../../bar-state-provider';

export const Link = () => {
  const { linkUrl, linkColor, linkText, barSize, barSizeMobile, editMode } =
    useSettings();

  const isMobile = useIsMobile();
  const { stopDisplayTrigger } = useBarState();

  const fontStyle = getStyleConfig(isMobile).link[
    isMobile ? barSizeMobile : barSize
  ] as TextStyleValue;

  const clickHandler: MouseEventHandler = (e) => {
    stopDisplayTrigger(StopDisplayTriggerTypes.ACTIONELEMENT);
    if (linkUrl.value) {
      openWindowByLink(e, {
        ...linkUrl,
        target: editMode ? '_blank' : linkUrl.target
      });
    }
  };

  return (
    <StyledLink _color={linkColor} _font={fontStyle} onClick={clickHandler}>
      {linkText}
    </StyledLink>
  );
};

const StyledLink = styled.a<{ _font: TextStyleValue; _color: string }>`
  font-size: ${({ _font }) => _font?.fontSize}px;
  font-weight: ${({ _font }) => _font?.fontWeight};
  color: ${({ _color }) => _color};
  cursor: pointer;
  text-decoration: underline;

  &:hover,
  &:active {
    color: ${({ _color }) => _color};
  }
`;
